// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"H1-z"};